'use strict';

/*Safari session storage fix*/
try {
  sessionStorage.setItem('localStorage', 1);
  sessionStorage.removeItem('localStorage');
} catch (err) {
  console.trace(err);
  window.sessionStorage = require('./sessionStorage');
}


if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function (callback, type, quality) {

      var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
        len = binStr.length,
        arr = new Uint8Array(len);

      for (var i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      callback(new Blob([arr], {type: type || 'image/png'}));
    }
  });
}


if (!String.prototype.format) {
  String.prototype.format = function (args) {
    args = args || [];
    return this.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
        ;
    });
  };
}

if (!Promise.allSettled) {
  Promise.allSettled = (promiseArray = []) => {
    const wrappedPromises = promiseArray.map(promise =>
      Promise.resolve(promise).then(
        value => ({ status: 'fulfilled', value }),
        error => ({ status: 'rejected', reason: error })
      )
    );
    return Promise.all(wrappedPromises);
  };
}

if(!Element.prototype.scrollBy) {
  Element.prototype.scrollBy = function(x, y) {
    if(x) $(this).scrollLeft($(this).scrollLeft() + x);
    if(y) $(this).scrollTop($(this).scrollTop() + y);
  };
}
